"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var formik_1 = require("formik");
var antd_1 = require("antd");
var FormItem_1 = require("../FormItem");
var contexts_1 = require("../../contexts");
var FormTextArea = function (props) {
    var name = props.name, onInputChange = props.onChange, restProps = __rest(props, ["name", "onChange"]);
    return (react_1.default.createElement(contexts_1.PermissionContext.Consumer, null, function (_a) {
        var allowEdit = _a.allowEdit;
        return (react_1.default.createElement(formik_1.Field, { name: name }, function (_a) {
            var _b = _a.field, value = _b.value, onChange = _b.onChange, onBlur = _b.onBlur;
            return (react_1.default.createElement(antd_1.Input.TextArea, __assign({ name: name, value: value, onChange: function (e) {
                    onChange(e);
                    if (onInputChange)
                        onInputChange(e);
                }, onBlur: onBlur, disabled: !allowEdit }, restProps)));
        }));
    }));
};
exports.default = FormItem_1.withFormItem(FormTextArea);
